import {enableProdMode} from '@angular/core';
import {environment} from './environments/environment';
import {bootstrapApplication} from "@angular/platform-browser";
import {tcAppConfig} from "./tc.app.config";
import {AppComponent} from "./app/app.component";

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, tcAppConfig).catch(err => console.error(err));
